(function setupDarkMode() {
  let enable = false
  
  const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)')?.matches;
  if (prefersDarkScheme) {
    enable = true
  }

  const setting = localStorage.getItem("dark_mode_on");
  if (setting === "true") {
    enable = true
  } else if (setting === "false") {
    enable = false
  }

  if (enable) {
    document.body.classList.add("dark-mode");
  }

  window.addEventListener("DOMContentLoaded", function () {
    const checkbox = document.querySelector("#dark-mode-checkbox");
    const checkboxMobile = document.querySelector("#dark-mode-checkbox-mobile");

    if (enable) {
      checkbox.checked = true
      checkboxMobile.checked = true
    }

    checkbox.addEventListener("click", function (e) {
      const isChecked = e.target.checked;
      if (isChecked) {
        localStorage.setItem("dark_mode_on", "true");
        document.body.classList.add("dark-mode");
        checkbox.checked = true
        checkboxMobile.checked = true
      } else {
        localStorage.setItem("dark_mode_on", "false");
        document.body.classList.remove("dark-mode");
        checkbox.checked = false
        checkboxMobile.checked = false
      }
    });
  });
})();
